import { useCallback, useEffect, useState } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { GetSaasMetricsAction } from '@/application/actions';
import type { SaasMetricsDTO } from '@/domain/repositories/IReportRepository';

export const useSaasMetrics = () => {
  const [metrics, setMetrics] = useState<SaasMetricsDTO | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<GetSaasMetricsAction>(TYPES.GetSaasMetricsAction);
      setMetrics(await action.execute());
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load SaaS metrics'));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { metrics, isLoading, error, refetch: load };
};
